import { render, staticRenderFns } from "./SimulationCharacter.vue?vue&type=template&id=6e5fc9e7&scoped=true"
import script from "./SimulationCharacter.vue?vue&type=script&lang=js"
export * from "./SimulationCharacter.vue?vue&type=script&lang=js"
import style0 from "./SimulationCharacter.vue?vue&type=style&index=0&id=6e5fc9e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5fc9e7",
  null
  
)

export default component.exports